import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import type { ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

import ApplicationBuilder from "@/modules/application/admin/components/ApplicationBuilder";
import { fetchApplicationVersionQueryOptions } from "@/modules/application/admin/services";

const searchSchema = z.object({
  step: z.number().optional(),
});

export const Route = createFileRoute(
  "/admin/_panel/_application/application/applications/$id",
)({
  component: Component,
  parseParams: (params) => ({
    id: z.number().int().parse(Number(params.id)),
  }),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "application.application.update");

    return {
      compactMenu: true,
      hideCrumb: true,
      crumb: [
        {
          label: context.t("Edit Process", { ns: "application.admin" }),
        },
      ],
    } satisfies ChildRouteContext;
  },
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchApplicationVersionQueryOptions(opts.params.id),
    ),
});

function Component() {
  const { id } = Route.useParams();
  const { step } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <ApplicationBuilder
      id={id}
      step={step || 0}
      onChangeStep={(step) => {
        navigate({ search: { step } });
      }}
    />
  );
}
